import { render } from "./TitleBar.vue?vue&type=template&id=486f82fa&scoped=true"
import script from "./TitleBar.vue?vue&type=script&lang=js"
export * from "./TitleBar.vue?vue&type=script&lang=js"

import "./TitleBar.vue?vue&type=style&index=0&id=486f82fa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-486f82fa"

export default script